import { Typography } from "@mui/material";
import { PopupMessage } from "../../../components/PopupMessage";

export const Disclaimer = ({ handleClick }: { handleClick: () => void }) => {
  return (
    <PopupMessage onClose={handleClick}>
      <Typography data-automation="disclaimer-body">
        All content contained within these pages is provided for information purposes only.
        For further clarification of this information or answers to any questions
        please contact Automatic Data Processing Pay Office (ADP) 1-888-207-0727.
      </Typography>
    </PopupMessage>
  );
}